import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import type ApiContent from 'src/core/models/api/ApiContent';
import { exerciseOpensInDialog } from 'src/core/utils/Exercise';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';

const initialState = {
	selectedExercise: null as ApiContent | null,
};

export const useExerciseStore = create(
	combine({ ...initialState }, (set) => {
		const reset = () => set({ ...initialState });

		const open = (exercise: ApiContent) => {
			if (!exerciseOpensInDialog(exercise)) {
				useLeaveAppStore.getState().confirmLeaving({ url: exercise.url });

				return;
			}

			set({ selectedExercise: exercise });
		};

		const close = () => reset();

		return { open, close, reset };
	}),
);
